import React, { useState } from 'react';
import { Box } from '@material-ui/core';
import { useParams } from "react-router-dom";
import { useDialog } from 'muibox';
import { defaultAlertOptions } from 'config/muibox';
import { format } from 'date-fns';
import ObleaTanques from './ObleaTanques';
import ObleaDesinfeccion from './ObleaDesinfeccion';
import CertificadosService from 'services/axios/CertificadosService';
import { mensajesGenerales } from 'config/mensajes';
import { Loading } from 'components/Loading';
import LogoCompleto from 'assets/images/logo-completo.png';

const mensajes = {
  ...mensajesGenerales
}

declare global {
  interface Window { recaptchaVerifier: any; recaptchaWidgetId: any }
}

interface RouteParams {
  id: string
}

interface FetchedData {
  id: number;
  item: string;
  descripcion: string;
}

export default function Obleas() {
  const dialog = useDialog();
  const { id } = useParams<RouteParams>();
  const [fetchedData, setFetchedData] = useState<FetchedData[]>();
  const [tipoCertificado, setTipoCertificado] = useState<string>('');

  React.useEffect(() => {
    const fetchData = async () => {
      try {
        if (id) {
          const oblea = await CertificadosService.fetchOblea(id);
          if (!oblea) return; //ts: para no tener que poner certificado! a cada uno
          const fechaTratamiento = format(new Date(oblea.fechaTratamiento).setHours(0, 0, 0), "dd/MM/yyyy");
          const fechaVencimiento = format(new Date(oblea.fechaVencimiento).setHours(0, 0, 0), "dd/MM/yyyy");
          setTipoCertificado(oblea.tipoCertificado);
          let data: FetchedData[] = [
            { id: 0, item: "Código de Oblea", descripcion: `${oblea.id}` },
            { id: 1, item: "Domicilio", descripcion: oblea.domicilio },
            { id: 2, item: "Tratamiento", descripcion: fechaTratamiento },
            { id: 3, item: "Vencimiento", descripcion: fechaVencimiento },
            { id: 4, item: "Periodo", descripcion: `${oblea.fechaMes} ${oblea.fechaAno}` },
            { id: 5, item: "Empresa", descripcion: oblea.empresa },
            { id: 6, item: "Nro. Registro Empresa", descripcion: oblea.nroRegistroEmpresa },
            { id: 7, item: "DT", descripcion: oblea.dt },
            { id: 8, item: "Nro. Registro DT", descripcion: oblea.nroRegistroDT },
          ];
          if (oblea.tipoCertificado.startsWith('desinfeccion')) {
            data = data.concat([
              { id: 9, item: "Productos y metodología utilizados", descripcion: oblea.productosUtilizados },
            ]);
          } else if (oblea.tipoCertificado.startsWith('tanques')) {
            data = data.concat([
              { id: 9, item: "Informe del estado de los tanques", descripcion: oblea.estadoTanque! },
              { id: 10, item: "Resultado ensayos bacteriológicos", descripcion: oblea.resultadoBacteriologico! },
              { id: 11, item: "Productos utilizados y concentración", descripcion: oblea.productosUtilizados }
            ]);
          }
          setFetchedData(data);
        } else {
          dialog.alert({
            ...defaultAlertOptions,
            title: mensajes.formValidacion.haOcurridoUnError,
            message: `No se encontró una Oblea con el ID solicitado`
          });
        }
      } catch (error) {
        error && //if not cancelled 
          dialog.alert({
            ...defaultAlertOptions,
            title: mensajes.formValidacion.haOcurridoUnError,
            message: `${error.message}`
          });
      }
    }
    fetchData();
  }, [dialog, id]);

  return (
    <React.Fragment>
      <Box display="flex" justifyContent="center" padding="16px" >
        <img src={LogoCompleto} width={320} alt='Dr. Fumigaciones' />
      </Box>
      {!fetchedData && <Loading backgroundColor="#ebebeb" />}
      {
        fetchedData &&
        <React.Fragment>
          {tipoCertificado.startsWith("tanques") && <ObleaTanques data={fetchedData} />}
          {tipoCertificado.startsWith("desinfeccion") && <ObleaDesinfeccion data={fetchedData} />}
        </React.Fragment >
      }
    </React.Fragment>

    // <div className={classes.root} style={{ backgroundColor: '#fff' }} >
    //   <div className={classes.appBarSpacer}></div>
    //   <AppBar position="fixed" className={classes.appBar}>
    //     <Toolbar className={classes.toolBar}>
    //       <div className={classes.title}>
    //         <img src={Logo} alt="Dr. Fumigaciones" style={{ height: 29 }} />
    //       </div>
    //     </Toolbar>
    //   </AppBar >
    //   {!fetchedData && <Loading backgroundColor="#ebebeb" />}
    //   {
    //     fetchedData &&
    //     <React.Fragment>
    //       {tipoCertificado.startsWith("tanques") && <ObleaTanques data={fetchedData} />}
    //       {tipoCertificado.startsWith("desinfeccion") && <ObleaDesinfeccion data={fetchedData} />}
    //     </React.Fragment >
    //   }
    // </div>
  );

  // if (fetchedData.error) {
  //   return (
  //     <React.Fragment>
  //       <Grid container direction="column" justify="center" alignItems="center">
  //         <Grid item style={{ marginBottom: '2rem' }}>
  //           <Typography variant="h6" style={{ textAlign: 'center' }}>
  //             Necesitamos que verifiques que no eres un Robot para poder acceder a la oblea
  //           </Typography>
  //         </Grid>
  //         <Grid item style={{ marginBottom: '2rem' }}>
  //           <div style={{ textAlign: 'center', display: 'inline-block' }}
  //             ref={(ref) => recaptcha = ref}>
  //           </div>
  //         </Grid>
  //       </Grid>
  //     </React.Fragment>
  //   );
  // }
  // if (!captchaSolved) { return (<div>error en el captcha</div>); }
  // if (data && data.error) {
  //   return <React.Fragment>Hubo un error al recuperar los datos: {data.error.message}</React.Fragment>
  // }
  // else if (data) {
  //   return (
  //     <React.Fragment>
  //       {tipoCertificado === "tanquesCABA" && <ObleaTanquesCABA data={data} />}
  //       {tipoCertificado === "desinfeccionCABA" && <ObleaDesinfeccionCABA data={data} />}
  //       {tipoCertificado === "tanquesGBA" && <ObleaTanquesCABA data={data} />}
  //       {tipoCertificado === "desinfeccionGBA" && <ObleaDesinfeccionCABA data={data} />}
  //     </React.Fragment >
  //   );
  // } else {
  //   return (
  //     <Box style={{ display: 'flex', flexGrow: 1, justifyContent: 'center', padding: '3rem', }} >
  //       <CircularProgress color="secondary" />
  //     </Box >
  //   );
  // }
}
